module["exports"] = [
  "in",
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org",
  "co.in"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/internet/domain_suffix.js
// module id = 704
// module chunks = 0